module.exports = __webpack_public_path__ + "img/d3.09f3882b.png";